"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSignUpValidateSchema = void 0;
var useSignUpValidateSchema_1 = require("./useSignUpValidateSchema");
Object.defineProperty(exports, "useSignUpValidateSchema", { enumerable: true, get: function () { return useSignUpValidateSchema_1.useSignUpValidateSchema; } });
